<template>
  <div class="poi-picker">
    <rich-button class="poi-picker-btn" :disabled="disabled" outline @click="showPopup">{{
      showValue
    }}</rich-button>
  </div>
</template>

<script type="text/ecmascript-6">
import { getBDLocale, i18n } from '@/common/utils/i18n'
import { mapGetters } from 'vuex'

// 不走vue数据响应
// const tempGeo = null
export default {
  name: 'PoiPicker',
  inject: ['rootForm'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      required: true
    },
    addrKey: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: i18n.gettext('校准POI')
    }
  },
  data () {
    return {
      // map instance
      map: null,
      showMap: false,
      currentGeo: {},
      language: getBDLocale(),
      zoom: 13,
      loadingToast: null
    }
  },
  computed: {
    ...mapGetters(['geo']),
    showValue () {
      return (this.value.lng && this.value.lat)
        ? this.gettext('已校准')
        : this.gettext('点击校准')
    }
  },
  methods: {
    showPopup () {
      const FullScreenPoiPicker = this.$createFullScreenPoiPicker({
        value: this.value,
        addrKey: this.addrKey,
        title: this.title,
        zoom: 17,
      }).show()
      FullScreenPoiPicker.$on('confirm', (data) => {
        this.$emit('input', data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.poi-picker {
  &-btn {
    padding: 10px;
    text-align: left;
    color: $color-light-grey;
    font-size: $fontsize-medium;
  }
  ::v-deep .rich-btn-outline:after {
    border: none;
  }
  .panel-wrap {
    width: 100%;
    position: absolute;
    top: 60px;
    bottom: 0;
    overflow: hidden;
  }
  .locate-btn {
    position: absolute;
    left: 10px;
    bottom: 24px;
    width: 30px;
    height: 30px;
    background: #fff;
    z-index: 99;
    text-align: center;
    i {
      line-height: 30px;
      font-size: 22px;
    }
  }
}
</style>
